import { WORK_ORDER_STORE_NAME } from '@/constants/constants';
import { Pagination, WorkOrder } from '@/types/types';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { clearClientStores } from '@/stores/clearClientStores';

type WorkOrderState = {
  isStoreHydrated: boolean;
  isLoading: boolean;
  updatedAt: Date | null;
  selectedWorkOrder: string | null;
  showDeletePopup: boolean;
  pagination: Pagination;
  workOrders: WorkOrder[]; // Work orders without status separation
  analyzedWorkOrders: WorkOrder[];
  processingAnalyzedWorkOrders: WorkOrder[];
  processingWorkOrders: WorkOrder[];
};

type Actions = {
  setIsStoreHydrated: (isHydrated: boolean) => void;
  setSelectedWorkOrder: (id: string | null) => void;
  updatePagination: (update: Partial<Pagination>) => void;
  //   fetchWorkOrders: () => Promise<void>;
  fetchAnalyzedWorkOrders: () => Promise<void>;
  fetchProcessingAndAnalyzedWorkOrders: () => Promise<void>;
  resetStore: () => void;
  //   fetchProcessingWorkOrders: () => Promise<void>;
  //   updateAnalyzedWorkOrderList: (workOrder: WorkOrder[]) => void;
  //   updateProcessingWorkOrderList: (workOrder: WorkOrder[]) => void;
  //   updateWorkOrderList: (workOrder: WorkOrder[]) => void;
  //   setShowDeletePopup: (showPopup: boolean) => void;
  //   toggleShowPopup: () => void;
};
const baseUrl = process.env.NEXT_PUBLIC_MARK_2_API;
export const useWorkOrderStore = create<WorkOrderState & Actions>()(
  persist(
    (set, get) => ({
      isStoreHydrated: false,
      isLoading: false,
      updatedAt: null,
      selectedWorkOrder: null,
      showDeletePopup: false,
      pagination: {
        totalResources: 0,
        totalPages: 0,
        currentPage: 1,
        resourcesPerPage: 16,
        // resourcesPerPage: 25,
        sort: 'desc'
      },
      workOrders: [], // Work orders without status separation
      analyzedWorkOrders: [],
      processingAnalyzedWorkOrders: [],
      processingWorkOrders: [],

      fetchAnalyzedWorkOrders: async () => {
        set((state) => ({ isLoading: (state.isLoading = true) }));
        const sort = get().pagination.sort;
        const page = get().pagination.currentPage;
        const limit = get().pagination.resourcesPerPage;

        try {
          const res = await fetch(
            `${baseUrl}api/v2/work-order/analyzed?sort=${sort}&page=${page}&limit=${limit}`,
            {
              method: 'GET',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json'
              }
            }
          );

          if (res.status === 200) {
            const parsed = await res.json();
            // console.log('Parsed Analyzed work orders: ', parsed);
            const pagination = {
              totalResources: parsed.data.totalResources,
              totalPages: parsed.data.totalPages,
              currentPage: parsed.data.currentPage
            };
            // console.log('Pagination: ', pagination);
            set((state) => ({
              analyzedWorkOrders: (state.analyzedWorkOrders =
                parsed.data.resources)
            }));

            set((state) => ({
              pagination: {
                ...state.pagination,
                ...pagination
              }
            }));

            set((state) => ({ updatedAt: (state.updatedAt = new Date()) }));
            set((state) => ({ isLoading: (state.isLoading = false) }));
          } else if (res.status === 401) {
            if (window !== undefined) {
              clearClientStores();
              window.location.assign('/auth/logout');
            }
          } else {
            set((state) => ({
              analyzedWorkOrders: (state.analyzedWorkOrders = [])
            }));
          }

          set((state) => ({ isLoading: (state.isLoading = false) }));
        } catch (error) {
          console.log('ERROR FROM WORKORDER STORE: ', error);
          // set((state) => ({
          //   analyzedWorkOrders: (state.analyzedWorkOrders = [])
          // }));
          // get().resetStore();
          get().resetStore();
          set((state) => ({ isLoading: (state.isLoading = false) }));
          throw error;
        }
      },
      fetchProcessingAndAnalyzedWorkOrders: async () => {
        set((state) => ({ isLoading: (state.isLoading = true) }));
        const sort = get().pagination.sort;
        const page = get().pagination.currentPage;
        const limit = get().pagination.resourcesPerPage;

        try {
          const res = await fetch(
            `${baseUrl}api/v2/work-order/processing-analyzed?sort=${sort}&page=${page}&limit=${limit}`,
            {
              method: 'GET',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json'
              }
            }
          );

          if (res.status === 200) {
            const parsed = await res.json();
            // console.log('Parsed Analyzed work orders: ', parsed);
            const pagination = {
              totalResources: parsed.data.totalResources,
              totalPages: parsed.data.totalPages,
              currentPage: parsed.data.currentPage
            };
            // console.log('Pagination: ', pagination);
            set((state) => ({
              processingAnalyzedWorkOrders:
                (state.processingAnalyzedWorkOrders = parsed.data.resources)
            }));

            set((state) => ({
              pagination: {
                ...state.pagination,
                ...pagination
              }
            }));

            set((state) => ({ updatedAt: (state.updatedAt = new Date()) }));
            set((state) => ({ isLoading: (state.isLoading = false) }));
          } else if (res.status === 401) {
            if (window !== undefined) {
              clearClientStores();
              window.location.assign('/auth/logout');
            }
          } else {
            set((state) => ({
              processingAnalyzedWorkOrders:
                (state.processingAnalyzedWorkOrders = [])
            }));
          }

          set((state) => ({ isLoading: (state.isLoading = false) }));
        } catch (error) {
          console.log('ERROR FROM WORKORDER STORE: ', error);
          // set((state) => ({
          //   analyzedWorkOrders: (state.analyzedWorkOrders = [])
          // }));
          // get().resetStore();
          get().resetStore();
          set((state) => ({ isLoading: (state.isLoading = false) }));
          throw error;
        }
      },
      updatePagination: (update: Partial<Pagination>) => {
        set((state) => ({
          pagination: { ...state.pagination, ...update }
        }));
      },

      setSelectedWorkOrder: (id: string | null) => {
        set((state) => ({
          selectedWorkOrder: (state.selectedWorkOrder = id)
        }));
      },
      setIsStoreHydrated: (isHydrated: boolean) => {
        set((state) => ({
          isStoreHydrated: (state.isStoreHydrated = isHydrated)
        }));
      },
      resetStore: () => {
        set((state) => ({
          // isStoreHydrated: (state.isStoreHydrated = false),
          isLoading: (state.isLoading = false),
          updatedAt: (state.updatedAt = null),
          selectedWorkOrder: (state.selectedWorkOrder = null),
          showDeletePopup: (state.showDeletePopup = false),
          pagination: (state.pagination = {
            totalResources: 0,
            totalPages: 0,
            currentPage: 1,
            resourcesPerPage: 16,
            sort: 'desc'
          }),
          workOrders: (state.workOrders = []),
          analyzedWorkOrders: (state.analyzedWorkOrders = []),
          processingAnalyzedWorkOrders: (state.processingAnalyzedWorkOrders =
            []),
          processingWorkOrders: (state.processingWorkOrders = [])
        }));
      }
    }),
    {
      name: WORK_ORDER_STORE_NAME,
      onRehydrateStorage: () => (state) => {
        state?.setIsStoreHydrated(true);
      }
    }
  )
);
